import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Company } from "../../../model/company";

class DataForCompanyCreation {
  company: Company = new Company();
  isRegistrationRequest = false;
}

@Component({
  selector: 'aw-create-company',
  templateUrl: './create-company-dialog.component.html',
  styleUrls: ['./create-company-dialog.component.scss']
})
export class CreateCompanyDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataForCompanyCreation,
    public dialogRef: MatDialogRef<CreateCompanyDialogComponent>,
  ) {


  }

  ngOnInit(): void {
  }


}


